/* ============================================================
   Hond & Buiten — PDP enhancements (gedeeld, alleen productpagina)
   ============================================================ */
(function () {
  'use strict';

  var COPY = {
    mainNoSize: 'Kies eerst je maat',
    stickyNoSize: 'Kies je maat'
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initPicker(picker) {
    if (!picker || picker.dataset.hbGateInit === 'true') return;
    picker.dataset.hbGateInit = 'true';

    var productInfo =
      picker.closest('.product-information') || picker.closest('.shopify-section') || document;

    function getSize() {
      return productInfo.querySelector('.variant-option--buttons[data-hb-size="true"]');
    }
    if (!getSize()) return;

    var params = new URLSearchParams(window.location.search);
    var state = { sizeChosen: params.has('variant') };

    function mainAtcBtn() {
      return productInfo.querySelector('product-form-component [ref="addToCartButton"]');
    }
    function stickyRoot() {
      return (
        document.querySelector('sticky-add-to-cart[data-product-id="' + (picker.dataset.productId || '') + '"]') ||
        document.querySelector('sticky-add-to-cart')
      );
    }
    function stickyBtn() {
      var s = stickyRoot();
      return s ? s.querySelector('[ref="addToCartButton"]') : null;
    }
    function stickyVariantEl() {
      var s = stickyRoot();
      return s ? s.querySelector('.sticky-add-to-cart__variant') : null;
    }
    function anySizeChecked() {
      var fs = getSize();
      return !!(fs && fs.querySelector('input:checked'));
    }
    function setMainBtnText(btn, txt) {
      var el =
        btn.querySelector('.add-to-cart-text__content span span') ||
        btn.querySelector('.add-to-cart-text__content span') ||
        btn.querySelector('.add-to-cart-text__content');
      if (el) el.textContent = txt;
    }

    function applyGate() {
      if (state.sizeChosen) return;
      var fs = getSize();
      if (fs) {
        fs.querySelectorAll('input').forEach(function (i) {
          if (i.checked) i.checked = false;
          i.setAttribute('data-current-checked', 'false');
        });
      }
      var b = mainAtcBtn();
      if (b) {
        b.setAttribute('disabled', '');
        b.dataset.hbGated = 'true';
        setMainBtnText(b, COPY.mainNoSize);
        var icon = b.querySelector('.add-to-cart-icon');
        if (icon) icon.style.display = 'none';
      }
      var s = stickyRoot();
      if (s) s.setAttribute('data-variant-available', 'true');
      var sv = stickyVariantEl();
      if (sv) {
        sv.textContent = COPY.stickyNoSize;
        sv.style.display = 'block';
      }
      var sb = stickyBtn();
      if (sb) {
        sb.setAttribute('disabled', '');
        sb.dataset.hbGated = 'true';
      }
    }

    function releaseGate() {
      state.sizeChosen = true;
      var b = mainAtcBtn();
      if (b && b.dataset.hbGated) {
        delete b.dataset.hbGated;
        b.removeAttribute('disabled');
        var icon = b.querySelector('.add-to-cart-icon');
        if (icon) icon.style.display = '';
      }
      var sb = stickyBtn();
      if (sb && sb.dataset.hbGated) {
        delete sb.dataset.hbGated;
        sb.removeAttribute('disabled');
      }
    }

    productInfo.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input') && t.closest('.variant-option--buttons[data-hb-size="true"]')) {
        releaseGate();
      }
    });

    document.addEventListener('variant:update', function () {
      if (state.sizeChosen) return;
      setTimeout(applyGate, 0);
    });

    productInfo.addEventListener('submit', function (e) {
      if (!state.sizeChosen || !anySizeChecked()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudgeSize();
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (state.sizeChosen) return;
      var t = e.target.closest && e.target.closest('.sticky-add-to-cart__button');
      if (t) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var fs = getSize();
        if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        nudgeSize();
      }
    }, true);

    function nudgeSize() {
      var fs = getSize();
      if (!fs) return;
      fs.classList.add('hb-size-nudge');
      setTimeout(function () { fs.classList.remove('hb-size-nudge'); }, 900);
    }

    applyGate();
  }

  function bindSizeHelp() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-hb-size-help]');
      if (!link) return;
      e.preventDefault();
      var guide = document.getElementById('hb-size-guide');
      if (!guide) return;
      if (guide.tagName === 'DETAILS' && !guide.open) guide.open = true;
      var d = guide.closest('details');
      if (d && !d.open) d.open = true;
      guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  ready(function () {
    document.querySelectorAll('variant-picker[data-section-id]').forEach(initPicker);
    if (!document.querySelector('variant-picker[data-hb-gate-init="true"]')) {
      var tries = 0;
      var iv = setInterval(function () {
        var p = document.querySelector('variant-picker');
        if (p) { initPicker(p); clearInterval(iv); }
        if (++tries > 20) clearInterval(iv);
      }, 150);
    }
    bindSizeHelp();
  });
})();
